export default __webpack_public_path__ + "files/7eaa3b990583dc1a5d69ae71b04cec1c.woff2";